var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.259106 4.56425L7.83252 7.80573C7.88596 7.82905 7.94302 7.84016 8.0002 7.84016C8.05737 7.84016 8.11417 7.82847 8.16787 7.80573L15.7411 4.56425C15.901 4.49565 16.0035 4.33729 15.9998 4.16335C15.9962 3.98931 15.8874 3.83521 15.725 3.77362L8.1515 0.893229C8.05363 0.855903 7.94592 0.855903 7.84831 0.893229L0.275111 3.77357C0.112699 3.83516 0.00388127 3.98957 9.07974e-05 4.1633C-0.00348909 4.33698 0.0990642 4.49591 0.259106 4.56425ZM7.99993 1.74798L14.4349 4.19536L7.99993 6.94977L1.56482 4.19541L7.99993 1.74798Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259106 6.40889L7.99993 9.72218L15.7406 6.40889C15.9574 6.31618 16.0576 6.06548 15.9649 5.84906C15.8725 5.63305 15.6226 5.53161 15.4052 5.62474L7.99993 8.79462L0.594352 5.62474C0.377664 5.53187 0.12723 5.63279 0.0345209 5.84906C-0.0581877 6.06575 0.0424704 6.31618 0.259106 6.40889Z",
    fill: "#AFAFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259106 8.11444L7.99993 11.4278L15.7406 8.11444C15.9574 8.02174 16.0576 7.7713 15.9649 7.55477C15.8725 7.33877 15.6226 7.23716 15.4052 7.33045L7.99993 10.5003L0.594352 7.3305C0.377664 7.23774 0.12723 7.3385 0.0345209 7.55482C-0.0581877 7.77135 0.0424704 8.02174 0.259106 8.11444Z",
    fill: "#AFAFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259106 9.82021L7.99993 13.1336L15.7406 9.82021C15.9574 9.72745 16.0576 9.47701 15.9649 9.26048C15.8725 9.04448 15.6226 8.9435 15.4052 9.03616L7.99993 12.206L0.594352 9.03616C0.377664 8.94345 0.12723 9.04421 0.0345209 9.26048C-0.0581877 9.47701 0.0424704 9.72745 0.259106 9.82021Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/ready.ac92740bd684089da5a906119eb9de67.svg";
export { ForwardRef as ReactComponent };